import { render, staticRenderFns } from "./message-concurrency-limit.vue?vue&type=template&id=1e3b6b2d&scoped=true"
import script from "./message-concurrency-limit.vue?vue&type=script&lang=ts"
export * from "./message-concurrency-limit.vue?vue&type=script&lang=ts"
import style0 from "./message-concurrency-limit.vue?vue&type=style&index=0&id=1e3b6b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b6b2d",
  null
  
)

export default component.exports